import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { SharedModule } from '../shared/shared.module'
import { PublicsRoutes } from './public.routing'

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(PublicsRoutes),
  ],
})
export class PublicModule { }
